/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-copy-link]');
  if (!button) return;

  var url = button.getAttribute('data-copy-link');
  var textEl = button.querySelector('[data-copy-link-text]');

  var fallbackCopy = function () {
    var textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    var succeeded = false;
    try {
      succeeded = document.execCommand('copy');
    } catch (error) {
      succeeded = false;
    }

    document.body.removeChild(textarea);
    return succeeded ? Promise.resolve() : Promise.reject(new Error('Copy command failed'));
  };

  var copyToClipboard = function () {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(url).catch(fallbackCopy);
    }

    return fallbackCopy();
  };

  copyToClipboard().then(function () {
    var copiedLabel = button.getAttribute('data-tooltip-copied');
    var originalLabel = button.getAttribute('data-tooltip');

    button.setAttribute('data-tooltip', copiedLabel);
    button.classList.add('is-copied');
    if (textEl) textEl.textContent = copiedLabel;

    window.clearTimeout(button._copyLinkTimeout);
    button._copyLinkTimeout = window.setTimeout(function () {
      button.setAttribute('data-tooltip', originalLabel);
      button.classList.remove('is-copied');
      if (textEl) textEl.textContent = originalLabel;
    }, 2000);
  }).catch(function () {
    window.prompt(button.getAttribute('data-tooltip') + ':', url);
  });
});

(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale = (window.Shopify && window.Shopify.locale) || undefined;

    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateSubtotal(container) {
    var unitPrice = parseInt(container.getAttribute('data-unit-price'), 10);
    var valueEl = container.querySelector('[data-subtotal-value]');
    if (isNaN(unitPrice) || !valueEl) return;

    var form = container.closest('form');
    var quantityInput = form ? form.querySelector('.quantity-selector__value') : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    valueEl.textContent = formatMoney(unitPrice * quantity);

    container.classList.add('is-updating');
    window.clearTimeout(container._subtotalFlashTimeout);
    container._subtotalFlashTimeout = window.setTimeout(function () {
      container.classList.remove('is-updating');
    }, 400);
  }

  function updateSubtotalsIn(scope) {
    scope.querySelectorAll('[data-product-subtotal]').forEach(updateSubtotal);
  }

  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!event.target.matches || !event.target.matches('.quantity-selector__value')) return;
      var form = event.target.closest('form');
      if (form) updateSubtotalsIn(form);
    });
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var form = event.target;
    if (!variant || !form.querySelectorAll) return;

    form.querySelectorAll('[data-product-subtotal]').forEach(function (container) {
      container.setAttribute('data-unit-price', variant.price);
      updateSubtotal(container);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateSubtotalsIn(document);
  });
})();

(function () {
  function updateGalleryCounter(carousel) {
    var wrapper = carousel.closest('.product-gallery__carousel-wrapper');
    var counter = wrapper && wrapper.querySelector('.product-gallery__counter');
    if (!counter) return;

    var visibleItems = carousel.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)');
    var selectedIndex = -1;
    visibleItems.forEach(function (item, index) {
      if (item.classList.contains('is-selected')) selectedIndex = index;
    });

    var currentEl = counter.querySelector('[data-gallery-counter-current]');
    var totalEl = counter.querySelector('[data-gallery-counter-total]');
    if (totalEl) totalEl.textContent = visibleItems.length;
    if (currentEl) currentEl.textContent = selectedIndex >= 0 ? selectedIndex + 1 : 1;
  }

  // Flickity (the carousel library) toggles the "is-selected"/"is-filtered" classes directly on
  // the slide elements as the user swipes or switches variants. Watching for that class change is
  // simpler and safer than hooking into Flickity's own instance from outside the theme's bundle.
  function watchCarousel(carousel) {
    if (carousel._galleryCounterObserverAttached) return;
    carousel._galleryCounterObserverAttached = true;

    updateGalleryCounter(carousel);
    new MutationObserver(function () {
      updateGalleryCounter(carousel);
    }).observe(carousel, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function scanForCarousels(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.product-gallery__carousel').forEach(watchCarousel);
  }

  scanForCarousels(document);

  // Quick view and any future AJAX re-render inject a fresh gallery into the DOM after this
  // script has already run, so keep watching for new ones instead of only checking once.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.product-gallery__carousel')) watchCarousel(node);
        scanForCarousels(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

function findJdgmWriteReviewButton() {
  // Judge.me's newer (Vue-based) widget uses a stable data-testid instead of the old
  // ".jdgm-write-rev-link" class, which only exists in their legacy widget. Try both so this
  // keeps working regardless of which widget version the store is on.
  return document.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
}

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.jdgm-scroll-to-widget');
  if (!trigger) return;

  var anchor = findJdgmWriteReviewButton() ||
    document.querySelector('.jdgm-widget-review_widget, .jdgm-rev-widg');
  if (!anchor) return;

  // Judge.me's own widget is what actually holds the reviews and the "Write a review" button now,
  // so send the click there instead of to our old (now removed) placeholder anchor.
  event.preventDefault();

  // A pedido (auditoría móvil): antes era un scrollIntoView() sin compensar
  // el header pegajoso (sticky) — dejaba el inicio del bloque de reviews
  // tapado detrás del header al llegar. El trigger (ver
  // sections/main-product.liquid) ya trae data-offset="30" pensado para
  // ESTE mismo salto (mismo atributo que el handler genérico de anclas en
  // assets/theme.js respeta), pero ese scrollIntoView() nunca lo leía.
  // Mismo cálculo que ese handler genérico: suma offsetTop subiendo por la
  // cadena de offsetParent hasta <body>, en vez de getBoundingClientRect()
  // (que da la posición ACTUAL en pantalla, no la del scroll final).
  var offset = parseInt(trigger.getAttribute('data-offset') || 0, 10);
  var top = 0;
  var walker = anchor;
  while (walker.offsetParent && walker.offsetParent.tagName !== 'BODY') {
    top += walker.offsetTop;
    walker = walker.offsetParent;
  }
  top += walker.offsetTop;
  window.scrollTo({ behavior: 'smooth', top: top - offset });
});

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.jdgm-open-write-review');
  if (!trigger) return;

  var jdgmWriteButton = findJdgmWriteReviewButton();
  if (!jdgmWriteButton) return;

  if (jdgmWriteButton.style.display === 'none') {
    jdgmWriteButton.style.display = '';
  }
  jdgmWriteButton.click();
});

(function () {
  // A pedido: "Add to Cart" debe verse siempre alineado en los carruseles
  // de productos (Recently viewed, Compare with similar products, etc.),
  // sin importar que una tarjeta tenga una imagen/título/vendor más alto
  // que otra. En una grilla normal (sin Flickity) esto ya funciona solo
  // (.product-list es flex y por default estira a los hijos a la misma
  // altura), pero Flickity.Cell.create() le pone position:absolute a cada
  // tarjeta (ver theme.js) para poder moverla con transform — eso la saca
  // del cálculo de flexbox, así que el stretch deja de aplicar y cada
  // tarjeta queda con SU PROPIA altura. Acá se mide la altura real de cada
  // tarjeta del carrusel y se les da a todas la misma min-height (la más
  // alta del grupo), para que el botón siempre termine a la misma altura.
  function equalizeRow(list) {
    var items = list.querySelectorAll('.product-item');
    if (items.length < 2) return;

    items.forEach(function (item) {
      item.style.minHeight = '';
    });

    var max = 0;
    items.forEach(function (item) {
      max = Math.max(max, item.getBoundingClientRect().height);
    });

    if (max > 0) {
      items.forEach(function (item) {
        item.style.minHeight = max + 'px';
      });
    }
  }

  function equalizeAll() {
    document.querySelectorAll('.product-list--scrollable').forEach(equalizeRow);
  }

  var resizeTimeout;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(equalizeAll, 150);
  });

  window.addEventListener('load', equalizeAll);
  document.addEventListener('DOMContentLoaded', equalizeAll);

  // Recently viewed / recomendaciones / complementary products se inyectan
  // vía fetch + innerHTML DESPUÉS de este primer pase (ver
  // RecentlyViewedProductsSection y similares en theme.js) — y Flickity
  // mueve las tarjetas dentro de su propio wrapper al inicializarse, lo
  // que también cuenta como cambio de nodos. Por eso se re-mide cada vez
  // que algo se agrega al DOM, en vez de una sola vez al cargar.
  var mutationTimeout;
  new MutationObserver(function () {
    window.clearTimeout(mutationTimeout);
    mutationTimeout = window.setTimeout(equalizeAll, 50);
  }).observe(document.body, { childList: true, subtree: true });
})();



/* ---------------------------------------------------------------------------
   Auditoría ordenador vs móvil — detalles menores de comportamiento
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  // 1) Escape cierra el mini-carrito y cualquier mega-menú/submenú abierto.
  //    El theme solo escucha Escape (keyup) con el foco dentro del propio
  //    componente; con el foco en otro lado no cerraba nada.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var cartToggle = document.querySelector('[data-action="toggle-mini-cart"][aria-expanded="true"]');
    if (cartToggle) cartToggle.click();

    var closedSomething = false;
    document.querySelectorAll('.nav-bar .is-dropdown-open').forEach(function (item) {
      var trigger = item.querySelector('[data-type="menuitem"]');
      var menu = item.querySelector('[aria-hidden]');
      item.classList.remove('is-dropdown-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.setAttribute('aria-hidden', 'true');
      var root = item.closest('[data-type="menu"]');
      if (root) root.classList.remove('nav-dropdown--glued');
      closedSomething = true;
    });
    // Si el foco quedó dentro del submenú que se acaba de cerrar, se suelta
    // (devolverlo al enlace padre reabriría el menú, porque ahí "focusin" abre).
    if (closedSomething && document.activeElement && document.activeElement.closest('.nav-bar')) {
      document.activeElement.blur();
    }
  });

  // 2) Buscador móvil: la "X" de borrar solo aparecía al enfocar con texto ya
  //    escrito (is-filled), nunca mientras se escribe.
  var phone = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!phone || !phone.matches || !input.classList || !input.classList.contains('search-bar__input')) return;
    input.classList.toggle('is-filled', input.value !== '');
  });

  // 3) Botón Atrás del navegador cierra un modal abierto (en vez de salir de
  //    la página). Al abrirse un modal se agrega UNA entrada de historial; si el
  //    modal se cierra por otro medio (X, fondo, Escape) y esa entrada sigue
  //    siendo la actual, se retira. Solo modales (.modal): los cajones de
  //    filtros no, porque aplicar filtros ya agrega sus propias entradas.
  var MODAL_STATE = 'csModalOpen';
  var ignorePop = false;

  function openModals() {
    return document.querySelectorAll('.modal[aria-hidden="false"]');
  }

  function closeTopModal() {
    var list = openModals();
    var top = list[list.length - 1];
    if (!top) return;
    var closeBtn = top.querySelector('[data-action="close-modal"]');
    if (closeBtn) closeBtn.click();
    else top.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-locked');
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var el = m.target;
      if (!el.classList || !el.classList.contains('modal') || m.oldValue === el.getAttribute('aria-hidden')) return;
      if (el.getAttribute('aria-hidden') === 'false') {
        if (!(window.history.state && window.history.state[MODAL_STATE])) {
          var state = Object.assign({}, window.history.state || {});
          state[MODAL_STATE] = true;
          window.history.pushState(state, '');
        }
      } else if (!openModals().length && window.history.state && window.history.state[MODAL_STATE]) {
        ignorePop = true;
        window.history.back();
      }
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'], attributeOldValue: true });

  window.addEventListener('popstate', function () {
    if (ignorePop) { ignorePop = false; return; }
    if (openModals().length) closeTopModal();
  });
})();


/* Nivel 3 (móvil): el botón Filter de la cabecera (.collection__header-filter) copia el
   conteo/estado del botón nativo de la barra, que el AJAX de filtros reemplaza completo. */
(function () {
  function sync() {
    var src = document.querySelector('.collection__toolbar-item--filter');
    var dst = document.querySelector('.collection__header-filter');
    if (!src || !dst) return;
    var label = dst.querySelector('[data-header-filter-label]');
    var srcIcon = src.querySelector('.collection__filter-icon');
    var dstIcon = dst.querySelector('.collection__filter-icon');
    if (label) {
      var clone = src.cloneNode(true);
      clone.querySelectorAll('.collection__filter-icon').forEach(function (n) { n.remove(); });
      label.innerHTML = clone.innerHTML.trim();
    }
    if (srcIcon && dstIcon) dstIcon.className = srcIcon.className;
  }
  function init() {
    var part = document.querySelector('.collection__dynamic-part');
    if (!part || !document.querySelector('.collection__header-filter')) return;
    new MutationObserver(sync).observe(part, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* A pedido: las tarjetas de un carrusel (Flickity: productos y colecciones) deben medir siempre lo mismo.
   Cada celda del carrusel se posiciona sola, así que su alto depende de su contenido (precio, título,
   badges). Aquí se mide la más alta y todas se igualan; el botón queda abajo por CSS (theme.css). */
(function () {
  function equalizeProductCards(slider) {
    var cells = [].slice.call(slider.children).filter(function (c) { return c.classList && (c.classList.contains('product-item') || c.classList.contains('collection-item')); });
    if (cells.length < 2) return;
    cells.forEach(function (c) { c.style.removeProperty('min-height'); });
    var max = 0;
    cells.forEach(function (c) { max = Math.max(max, c.getBoundingClientRect().height); });
    if (max > 0) cells.forEach(function (c) { c.style.setProperty('min-height', Math.ceil(max) + 'px', 'important'); });
  }

  var timer;
  function run() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll('.flickity-slider').forEach(equalizeProductCards);
    }, 120);
  }

  window.addEventListener('load', function () { run(); setTimeout(run, 800); });
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', run);
  // carruseles que se arman después (Recently viewed, recomendaciones) y imágenes que cargan tarde
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (muts[i].addedNodes.length && t.closest && (t.closest('.flickity-slider') || t.querySelector && t.querySelector('.product-item'))) { run(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('.flickity-slider')) run();
  }, true);
})();

/* mailto: y tel: NO deben abrirse en pestaña nueva. theme.js marca target="_blank" en todo enlace cuyo
   hostname difiere del de la página — y un enlace mailto:/tel: tiene hostname vacío, así que también lo recibía:
   el navegador abría una pestaña en blanco antes de pasar al programa de correo / llamadas. Aquí se les quita
   (ahora y en los que se agreguen después). Afecta a TODOS los enlaces mailto:/tel: del sitio. */
(function () {
  function fix(root) {
    (root || document).querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(function (a) {
      if (a.getAttribute('target') === '_blank') {
        a.removeAttribute('target');
        if (a.getAttribute('aria-describedby') === 'a11y-new-window-message') a.removeAttribute('aria-describedby');
      }
    });
  }
  function run() { fix(document); setTimeout(fix, 300); setTimeout(fix, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { fix(document); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* A pedido: la nota de Special Order cabe en un renglón — se reduce la fuente hasta que no desborde. */
(function () {
  function fit() {
    document.querySelectorAll('.product-form__shipping-note').forEach(function (el) {
      el.style.fontSize = '';
      if (window.innerWidth <= 768) return; // móvil: tamaño de fuente original, puede ocupar más de un renglón
      var size = parseFloat(getComputedStyle(el).fontSize);
      var min = 6;
      while (el.scrollWidth > el.clientWidth + 0.5 && size > min) {
        size -= 0.25;
        el.style.fontSize = size + 'px';
      }
    });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(fit, 60); }
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('variant:change', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Enlaces de los menús del admin con URL absoluta (https://citysupplygroup.com/...): se vuelven relativos para que
   naveguen dentro del mismo sitio (también en vistas previas del tema). Solo toca el dominio propio; no cambia
   "?view=", que sigue funcionando igual una vez asignadas las plantillas. */
(function () {
  var HOSTS = ['citysupplygroup.com', 'www.citysupplygroup.com', 'citysupplycompanyinc.myshopify.com'];
  function fix(root) {
    (root || document).querySelectorAll('a[href*="/pages/"]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        if (HOSTS.indexOf(u.hostname) === -1 && u.hostname !== location.hostname) return;
        // En páginas ("/pages/...") se quita "?view=hub|customer-service": la plantilla ya está asignada en el admin
        // (si faltara, main-page.liquid redirige a la vista completa).
        var v = u.searchParams.get('view');
        if (v === 'hub' || v === 'customer-service') u.searchParams.delete('view');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }
  document.addEventListener('DOMContentLoaded', function () { fix(); });
  window.addEventListener('load', function () { fix(); });
})();
